import React, { Component } from 'react';

import { AuthContext } from "../../authContext";
import AppContent from '../shared/AppContent';
import Button from "../shared/Button";
import FormControl from "../shared/form/FormControl";
import PageHeading from "../shared/PageHeading";
import TextInput from "../shared/form/TextInput";
import WebLink from "../shared/WebLink";

import { theme } from "../../configuration";

class LoginForm extends Component {
  state = {
    username: "",
    password: ""
  };
  static contextType = AuthContext;
  getStyle = isLoggingIn => {
    if (isLoggingIn) {
      return {
        width: '180px',
        padding: '10px',
        marginTop: '10px',
        backgroundColor: theme.colours.emphasis
      }
    }
    else {
      return {
        width: '180px',
        padding: '10px',
        marginTop: '10px'
      }
    }
  }
  handleLogin = async e => {
    e.preventDefault();
    await this.context.authenticate(this.state.username, this.state.password);
  };
  handleTextInputChange = e => {
    let a = {};
    a[e.target.name] = e.target.value;
    this.setState(a);
  };
  render() {
    return (
      <AppContent>
        <PageHeading>Client Login</PageHeading>
        <p>Please log in using your CityCAD client account.</p>
        <p style={{color:"#ff0000"}}>
          {this.context.isErrorAuthenticating && "Please check your username and password."}
          {this.context.isTokenExpired && "Your session has expired. Please log in again."}
        </p>
        <div>
          <form>
            <FormControl>
              <div style={{margin:"6px 0px 6px 0px"}}>User</div>
              <TextInput type="text" name="username" id="inputUsername" value={this.state.username} onChange={this.handleTextInputChange} />
            </FormControl>
            <FormControl>
              <div style={{margin:"6px 0px 6px 0px"}}>Password</div>
              <TextInput type="password" name="password" id="inputPassword" value={this.state.password} onChange={this.handleTextInputChange} />
            </FormControl>
            <div style={{display:"flex", justifyContent:"flex-end", maxWidth: "422px"}}>
              <Button type="submit" style={this.getStyle(this.context.isLoggingIn)} onClick={this.handleLogin}>
                {this.context.isLoggingIn ? "Authenticating" : "Log in"}
              </Button>
            </div>
          </form>
        </div>
        <div>
          <p>
            {/*<WebLink href={passwordResetUrl} target={`_blank`}>Forgotten password?</WebLink>*/}
            If you have forgotten your client details, please contact <WebLink href="mailto:support@citycadtechnologies.co.uk" target={`_blank`}>support@citycadtechnologies.co.uk</WebLink> for assistance.
          </p>
        </div>
      </AppContent>
    );
  }
}

export default LoginForm;
